// Model.jsx
import React, {useEffect, useRef, useState} from 'react';
import contactImage from "../Assets/contactIcon.png";
import {useNavigate} from "react-router-dom";
import Swal from "sweetalert2";
import home from "../Api/home";

const ModelContactUs = ({ onClose, title, message }) => {
    const modalRef = useRef(null);

    const handleOutsideClick = (e) => {
        if (modalRef.current && !modalRef.current.contains(e.target)) {
            onClose();
        }
    };

    useEffect(() => {
        document.body.style.overflow = 'hidden'; // Disable scrolling on the body when the modal is open
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.body.style.overflow = 'auto'; // Re-enable scrolling on the body when the modal is closed
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);


    const [contactData, setContactData] = useState(null);
    const navigate = useNavigate();

    const Toast = Swal.mixin({
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    })

    useEffect(() => {
        const fetchDashboardInfo = async () => {
            try {
                const response = await home();
                setContactData(response.data);
            } catch (error) {
                console.error("API Error:", error.message);
                if (error.response.status === 401 || error.response.status === 500) {
                    Toast.fire({
                        icon: 'error',
                        title: error.response.data.title
                    })
                    localStorage.clear();
                    navigate("/");
                }
                Toast.fire({
                    icon: 'error',
                    title: error.response.data.message
                })
            }
        };
        fetchDashboardInfo();
    }, []);

    const handleWhatsAppClick = () => {
        window.location.href = contactData?.data?.whatsappLink ?? ''
    }

    const handleTelegramClick = () => {
        window.location.href = contactData?.data?.telegram ?? ''
    }

    return (
        <div>
            <div className="modal-overlay"></div>

            <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: 'block' }}>
                <div className="modal-dialog modal-dialog-centered p-3 py-5" ref={modalRef}>
                    <div className="modal-content-contact">
                        <div className="container d-flex flex-column p-4">
                            <span className="fw-bold h6 text-pink mb-2">TeamLewis</span>

                            <span className="fs-1 text-white mb-3 fw-bold">
                                Contact Us
                            </span>

                            <div className="d-flex flex-column align-items-center">
                                <img src={contactImage} alt="contact Icon" className='my-4' width={80}/>

                                <span className="fs-5 text-white mb-3 fw-bold">
                                {title}
                                </span>

                                <span className="fs-6 lightGrey mb-3 fw-bold text-center">
                                {message}
                                </span>

                                <div className='d-flex justify-content-between w-100'>
                                    {/*<button className="sign-up-btn mt-3 px-4 py-3 mx-2 rounded-4" onClick={handleWhatsAppClick} >WhatsApp</button>*/}
                                    <button className="telegram-btn mt-3 px-4 py-3 mx-2 rounded-4" onClick={handleTelegramClick}>Telegram</button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModelContactUs;
